import { Global } from './loader.global'
import { Spinner } from './loader.spinner'

const Loader = () => <Global />

Loader.Global = Global
Loader.Spinner = Spinner

export default Loader
